<template>
    <div ref="tab" class="de-tab-wrapper">
        <div style="position:absolute;width:0px; height:0px">
            <Tabs class="de-tabs" :value="activedTabName" @on-click="change" 
            :style="{height:($refs.tab&&$refs.tab.clientHeight)+'px', width:($refs.tab&&$refs.tab.clientWidth)+'px'}">
                <TabPane v-for="(item,index) in tabs" :key="index" :label="item" :name="index+''">
                    <div :style="{height:(contentHeight-0)+'px'}">
                        <slot :name="getSlotIndex('content', index)" >
                            <h3>未指定内容</h3>
                        </slot>
                    </div>
                    <div style="height:0px"></div>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
export default {
    name: 'de-tab',
    props: ["activedIndex","labels","layoutConfig","loop","isEditing","editHeader","headerHeight","titleFontObj"],
    data() {
        return {
            activedIndex1:0,
            contentHeight:0
        }
    },
    created(){
        // this.$set(this, 'activedIndex1', 0);
    },
    computed:{
        tabs(){
            if(this.labels){
                let labels = this.labels.split(',');
                labels = labels.map((l,index)=>{
                    let slotIndex = this.getSlotIndex('header', index);
                    let headerContent;
                    if(slotIndex==-1){
                        headerContent = l;
                    }else{
                        headerContent = this.$slots[slotIndex];
                    }
                    return (h)=>{
                        return h('div',{
                            style:Object.assign({
                                height:this.headerHeight+'px',
                                lineHeight:this.headerHeight+'px',
                            }, this.titleFontObj, {
                                fontSize:this.titleFontObj?this.titleFontObj.fontSize+'px':'12px'
                            })
                        },[ headerContent ])
                    };
                })
                return labels;
            }else{
                return [];
            }
        },

        activedTabName(){
            if(this.activedIndex1!==undefined){
                return this.activedIndex1+'';
            }
        }
    },

    watch: {
        activedIndex:{
            handler(){
                if(this.activedIndex!==undefined){
                    this.activedIndex1 = this.activedIndex;
                }
            },
            immediate:true
        },
        activedIndex1:{
            handler(){
                if(this.activedIndex1!==undefined){
                    this.$emit('tab-changed', this.activedIndex1)
                }
            },
            immediate:true
        },
        loop:{
            handler(){
                if(this.loop>0&&!this.isEditing){
                    this.createLoop(this.loop*1000);
                }
            },
            immediate:true
        },
        headerHeight:{
            handler(){
                this.resize();
            }
        }
    },
    methods: {
        change(v) {
            this.activedIndex1 = v;
            this.$emit('tab-changed', v);
        },

        getSlotPosition(dropEvent, defaultSize){
            if(this.editHeader){
                let position = {
                    type:'header',
                    tabIndex:this.activedIndex,
                };
                return position;
            }else{
                let position = {
                    type:'content',
                    tabIndex:this.activedIndex,
                };
                return position;
            }
            
        },

        getSlotIndex(type, index){
            return this.layoutConfig.children.findIndex((child)=>{
                return child.slotInfo.position.type===type&&child.slotInfo.position.tabIndex===index;
            })
        },

        tabStyleObj(){
            console.log('height',this.$refs.tab&&this.$refs.tab.clientHeight);
            
            return {
                height:this.$refs.tab&&this.$refs.tab.clientHeight+'px'
            }
        },

        createLoop(time){
            if(this.loopInst){
                clearTimeout(this.loopInst);
            }
            this.loopInst = setTimeout(() => {
                let index = this.activedIndex1+1<this.tabs.length?this.activedIndex1+1:0;
                this.change(index)
                this.createLoop(time);
            }, time);
        },

        resize(){
            this.contentHeight = ((this.$refs.tab&&this.$refs.tab.clientHeight)-this.headerHeight-10);
            this.$nextTick().then(()=>{
                this.$emit('on-slot-resize')
            })
        }
    }
}
</script>

<style lang="less">
.de-tab-wrapper {
    position: relative;
}
</style>